import { BaseCard } from '@/shared/components'
import { useReferralSummary } from '../../hooks'
import { formatCurrency } from '@/shared/lib/currency'
import { Currencies } from '@/entities/curency'

interface TotalEarningsCardProps {
  amount?: number
}

export const TotalEarningsCard = ({ amount }: TotalEarningsCardProps) => {
  // TotalEarningsCard показывает общую сумму за все время, независимо от выбранной даты
  const { totalEarnings, isLoading } = useReferralSummary()

  return (
    <BaseCard
      padding="md"
      radius="md"
      variant="active"
      className="flex lg:flex-row flex-col justify-between gap-10 lg:gap-6 w-full min-w-[300px]"
    >
      <div className="flex flex-col flex-1 gap-2">
        <span className="font-klein font-medium text-text-secondary leading-[24px]">
          Заработано всего
        </span>
        <div className="font-klein font-medium text-lg">
          {isLoading ? '' : formatCurrency(amount ?? totalEarnings, Currencies.USDT)}
        </div>
      </div>
    </BaseCard>
  )
}
